import { useState } from 'react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import FormModalContainer from '../../components/Modals/FormModalContainer'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn'

const ModulesWithHover = ({ modules, companyName }) => {
  const [modulesModalStatus, setModulesModalStatus] = useState(false)

  return (
    <Box sx={styles.root}>
      {
        modules?.length > 0 ? (
          <Typography
            variant='body1'>{modules[0]?.name}{' '}{modules[1]?.name ? `, ${modules[1]?.name}` : ''}</Typography>
        ) : '---'}

      {
        modules?.length > 2 && (
          <Box sx={styles.moreContainer}>
            <Box sx={styles.moreBInfo} onClick={() => setModulesModalStatus(true)}>+{+`${modules?.length}` - 2} more</Box>
          </Box>
        )
      }

      <FormModalContainer
        modalState={modulesModalStatus}
        modalTitle={`modules for ${companyName}`}
        customStyle={styles.modalCustomStyle}
        handleClose={() => setModulesModalStatus(false)}>
        <Box sx={styles.popupModulesCount}>{modules?.length} Modules</Box>
        <Box sx={styles.modulesListContainer}>
          {modules?.map((singleModule) => (
            <Box sx={styles.singleModuleLi} key={singleModule.id}>{singleModule.name}</Box>
          ))}
        </Box>
        <OfoqThemeBtn onClick={() => setModulesModalStatus(false)} name='close' customStyle={styles.closeBtn} />
      </FormModalContainer>
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '10px',
      fontSize: { xs: '12px', sm: '16px' },
    },
  },
  moreBInfo: {
    color: 'primary.main',
    cursor: 'pointer',
  },
  modalCustomStyle: {
    maxWidth: '360px',
    fontFamily: 'Avenir',
  },
  modulesListContainer: {
    maxHeight: '300px',
    overflow: 'hidden',
    overflowY: 'scroll',
    marginBottom: '20px',
    display: 'block',

    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 0 grey',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#29cc8b',
      borderRadius: '10px',
    },
    scrollbarColor: '#29cc8b transparent',
    scrollbarWidth: 'thin',
  },
  popupModulesCount: {
    color: '#a9a9a9',
    backgroundColor: '#f7f7f7',
    padding: '5px 15px',
    margin: '0 -15px',
    marginBottom: '15px',
  },
  singleModuleLi: {
    padding: '10px 15px',
    margin: '0 -15px',
    marginBottom: '10px',
    borderBottom: '1px solid #d7d7d7',
    textTransform: 'capitalize',
  },
  closeBtn: {
    marginLeft: 'auto',
    display: 'flex',
    marginTop: '10px',
  },
}

export default ModulesWithHover
